/**
 * Tipos para o sistema de loading/autenticação
 */

export interface LoadingStep {
  id: string;
  label: string;
  progress: number;
}

export interface AuthValidationResult {
  success: boolean;
  error?: string;
  needsRefresh?: boolean;
}

export interface LoadingState {
  currentStep: number;
  progress: number;
  isComplete: boolean;
  error: string | null;
}

export type LoadingStepId =
  | "hydrating"
  | "validating-token"
  | "refreshing-token"
  | "validating-again"
  | "redirecting";

export const LOADING_STEPS: Record<LoadingStepId, LoadingStep> = {
  hydrating: {
    id: "hydrating",
    label: "Hidratando dados...",
    progress: 20,
  },
  "validating-token": {
    id: "validating-token",
    label: "Validando token...",
    progress: 40,
  },
  "refreshing-token": {
    id: "refreshing-token",
    label: "Renovando token...",
    progress: 60,
  },
  "validating-again": {
    id: "validating-again",
    label: "Validando novamente...",
    progress: 80,
  },
  redirecting: {
    id: "redirecting",
    label: "Redirecionando...",
    progress: 100,
  },
};
